module.exports = __webpack_public_path__ + "img/exhaustPipe-2.081abef1.jpg";